module.exports = __webpack_public_path__ + "img/06_no.25dffc21.svg";